import React from 'react';

/**
 * TemControl brand mark — concentric rings + amber time marker.
 *
 * Concept:
 *  - Outer thin ring   → full day / scope
 *  - Inner progress arc → worked/tracked time (3/4 of the cycle)
 *  - Amber pill marker → the present "fichaje" moment
 *
 * Variants:
 *  - "onLight": teal rounded-square background (light backdrops)
 *  - "onDark":  translucent white background (dark backdrops)
 *  - "bare":    no background — just the mark
 */
const Logo = ({ size = 40, variant = 'onLight', className = '' }) => {
  const radius = 224;

  let bgFill = '#0EA5E9';
  if (variant === 'onDark') bgFill = 'rgba(255, 255, 255, 0.14)';
  if (variant === 'bare') bgFill = 'transparent';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="TemControl"
    >
      {bgFill !== 'transparent' && (
        <rect width="1024" height="1024" rx={radius} fill={bgFill} />
      )}

      {/* Outer thin ring (full day) */}
      <circle cx="512" cy="512" r="380" fill="none" stroke="rgba(255,255,255,0.28)" strokeWidth="18" />

      {/* Inner track */}
      <circle cx="512" cy="512" r="236" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="72" />

      {/* Inner progress arc (worked time) */}
      <path
        d="M 512 276 A 236 236 0 1 1 276 512"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="72"
        strokeLinecap="round"
      />

      {/* Accent marker (fichaje) */}
      <rect x="476" y="110" width="72" height="44" rx="22" fill="#FB7185" />
    </svg>
  );
};

export default Logo;
